import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export default function useAuthorized() {
    const [authorized, setAuthorized] = useState(null)
    let user = useSelector(state => state.user.user)
   
    useEffect(() => {
        if(user){
            setAuthorized(user.is_admin)
        }
       
    }, [user])

    return { authorized }
}